import { AnimInfo, Slide, shape } from "../types/pgtypes";
import { AnimationContext } from "./animmanager";
import { PgReader } from "./pgreader";

export class Animation {
    private _$Status: any
    private u_presentation: any
    private randomNum: number
    // 随机可选的动画类型，有些动画类型不支持
    private randomList: number[] = [2, 19, 26, 9, 1, 18, 8, 15, 23, 21, 20, 30, 38, 25, 4, 6, 29, 14, 11, 7, 12, 0, 5, 10, 13, 17, 22, 33]

    constructor() {
        this._$Status = Object.create(null)
        this._$Status.other = Object.create(null)
        this.u_presentation = Object.create(null)
        this.u_presentation._$U_A_Cons = Object.create(null)
    }
    public play(c: AnimationContext) {
        let slide = c.slide, info = c.animInfo, shape = c.shape
        if (!shape) return
        this.animHandler(this._$Status, shape, c.g, c.count, info.animIdx, info.animType, info.endTime, info.direct, info.emphAttr, slide, info.textInfo, info.oldParaIdx, info.paraIdx)
    }
    public animHandler(_$Status, shape, ctx, count, animIdx, animType, endTime, direct, emphAttr, slide, textInfo?, oldParaIdx?, paraIdx?) {
        let animationType = 0,
            shapeRect = shape.shapeRect,
            textRect = shape.textRect,
            sx = shapeRect.x,
            sy = shapeRect.y,
            swidth = shapeRect.width,
            sheight = shapeRect.height,
            tx = textRect.x,
            ty = textRect.y,
            twidth = textRect.width,
            theight = textRect.height,
            pWidth = PgReader.instance.doc.pagesize.width,
            pHeight = PgReader.instance.doc.pagesize.height,
            sxy = _$Status.other.animDis,
            fillColor = [0, 0, 0, 1],
            shapeType = 1,
            u_presentation = this.u_presentation,
            self = this
        if (animType == 0) {
            //进入
            if (animIdx == 2) {
                //出现
                return;
            } else if (animIdx == 19) {
                //渐变
                return in_fade();
            } else if (animIdx == 3) {
                //飞入
                return in_flyer()
            } else if (animIdx == 26) {
                //上升
                return in_rise();
            } else if (animIdx == 9) {
                //劈裂
                return in_split();
            } else if (animIdx == 1) {
                //擦除
                return in_wipe();
            } else if (animIdx == 18) {
                //圆形扩展
                return in_circleDevelop();
            } else if (animIdx == 8) {
                //轮子
                return in_wheel();
            } else if (animIdx == 15) {
                //随机线条
                return in_linesRandom();
            } else if (animIdx == 23) {
                //翻转式由远及近
                return in_fadeturn();
            } else if (animIdx == 21) {
                //渐变式缩放
                return in_fadescale();
            } else if (animIdx == 20) {
                //渐变式回旋
                return in_faderound();
            } else if (animIdx == 35) {
                //弹跳 
                return in_jump();
            } else if (animIdx == 30) {
                //微软向下浮动 目前解析出來沒有此動畫
                return in_down();
            } else if (animIdx == 38) {
                // //wps浮动 目前解析出來沒有此動畫
                // return in_down();
            } else if (animIdx == 25) {
                // wps 渐入
                return in_slowmove();
            } else if (animIdx == 4) {
                // wps 盒状
                return in_box()
            } else if (animIdx == 6) {
                // wps 阶梯状
                return in_step()
            } else if (animIdx == 29) {
                // 缩放动画，不渐变
                return in_scale()
            } else if (animIdx == 14) {
                // 十字切入
                return in_cross()
            } else if (animIdx == 11) {
                // 切入
                return in_cut()
            } else if (animIdx == 7) {
                // 菱形
                return in_square()
            } else if (animIdx == 12) {
                // 闪烁一次
                return winkle_once()
            } else if (animIdx == 0) {
                // 百叶窗
                return in_windowshade();
            } else if (animIdx == 5) {
                // 缓慢进入
                return in_langsam();
            } else if (animIdx == 10) {
                // 棋盘
                return in_schachbrett()
            } else if (animIdx == 13) {
                // 扇形
                return in_sector()
            } else if (animIdx == 17) {
                // 向内溶解
                return in_loesung()
            } else if (animIdx == 16) {
                // 随机
                return in_random()
            } else if (animIdx == 22) {
                // 展开
                return in_offnen()
            } else if (animIdx == 33) {
                // 横展开
                return in_open()
            } else {
                // 当无此类型的动画的时候，直接按照出现类型执行
                return
            }
        } else if (animType == 1) {
            //强调
            if (animIdx == 16) {
                //忽明忽暗
                return empha_fadescale();
            } else if (animIdx == 24) {
                //闪动
                return empha_twinkle();
            } else if (animIdx == 23) {
                //跷跷板
                return empha_rotateborder();
            } else if (animIdx == 8) {
                //陀螺旋
                return empha_rotate();
            } else if (animIdx == 0) {
                //放大缩小
                return empha_scale();
            } else if (animIdx == 12) {
                //不饱和
                return empha_unsaturated();
            } else if (animIdx == 19) {
                //加深
                return empha_deepen();
            } else if (animIdx == 9) {
                //变浅
                return empha_shallow();
            } else if (animIdx == 7) {
                //透明
                return empha_transparent();
            } else if (animIdx == 17) {
                //混色
                return empha_colormix();
            } else if (animIdx == 10) {
                //补色
                return empha_colorrepair();
            } else if (animIdx == 2) {
                //更改线条颜色
                return empha_changeLineColor()
                // return empha_colorrepair();
                // animationType = u_presentation._$U_A_Cons._$A_EMPHA_ChangeLineColor;
            } else if (animIdx == 1) {
                //更改填充颜色
                return empha_changeFillColor()
                // return empha_colorrepair();
                // animationType = u_presentation._$U_A_Cons._$A_EMPHA_ChangeFillColor;
            } else if (animIdx == 18) {
                //加粗闪烁
                return boldtwinkle();
            } else {
                // 当无此类型的动画的时候，直接按照忽明忽暗类型执行
                return empha_fadescale();
            }
        } else if (animType == 2) {
            //退出
            if (animIdx == 17) {
                //消失
                return out_disappear();
            } else if (animIdx == 19) {
                //渐变
                return out_fade();
            } else if (animIdx == 2) {
                //飞入
                return out_flyer();
            } else if (animIdx == 31) {
                //下降
                return out_fall();
            } else if (animIdx == 8) {
                //劈裂
                return out_split();
            } else if (animIdx == 1) {
                //擦除
                return out_wipe();
            } else if (animIdx == 18) {
                //圆形扩展
                return out_circledevelopment();
            } else if (animIdx == 7) {
                //轮子
                return out_wheel();
            } else if (animIdx == 14) {
                //随机线条
                return out_linesrandom();
            } else if (animIdx == 21) {
                //渐变式缩放
                return out_fadescale();
            } else if (animIdx == 24) {
                //渐变式由近及远
                return out_fadeturn();
            } else if (animIdx == 20) {
                //渐变式回旋
                return out_faderound();
            } else if (animIdx == 35) {
                //弹跳
                return out_jump();
            } else if (animIdx == 27) {
                // 上升
                return out_rise()
            } else if (animIdx == 0) {
                // 百叶窗
                return out_windowshade()
            } else if (animIdx == 4) {
                // 缓慢退出
                return out_langsam()
            } else if (animIdx == 5) {
                // 阶梯型
                return out_step()
            } else if (animIdx == 9) {
                // 棋盘状
                return out_schachbrett()
            } else if (animIdx == 12) {
                // 扇形
                return out_sector()
            } else if (animIdx == 16) {
                // 向外溶解
                return out_loesung()
            } else if (animIdx == 6) {
                // 菱形退出
                return out_square()
            } else if (animIdx == 10) {
                // 切出
                return out_cut()
            } else if (animIdx == 3) {
                // 盒状退出
                return out_box()
            } else if (animIdx == 11) {
                // 闪烁退出
                return out_winkle()
            } else {
                // 当无此类型的动画的时候，直接按照渐变消失类型执行
                return out_fade();
            }
        } else if (animType == 3) {
            return path_all()
            //动作路径
            if (animIdx == 32) {
                //向下
                animationType = u_presentation._$U_A_Cons._$A_PATH_Down;
            } else if (animIdx == 33) {
                //向下弧线
                animationType = u_presentation._$U_A_Cons._$A_PATH_ArcDown;
            } else if (animIdx == 35) {
                //向下转
                animationType = u_presentation._$U_A_Cons._$A_PATH_TurnDown;
            } else if (animIdx == 15) {
                //圆形扩展
                animationType = u_presentation._$U_A_Cons._$A_PATH_Round;
            } else if (animIdx == 57) {
                //水平数字 8
                animationType = u_presentation._$U_A_Cons._$A_PATH_Draw8;
            }
        } else {
            // 当无此类型的动画的时候，直接按照出现类型执行
            return
        }

        function in_fade() {
            //进入渐变
            ctx.globalAlpha = count / (endTime * 60)
        }
        function in_flyer() {
            //进入飞入
            if (count == 0) {
                sxy = getDistance();
                _$Status.other.animDis = sxy;
            }
            var dx = sxy[0],
                dy = sxy[1];
            // if (_$Status.other.addTimes && _$Status.other.addTimes != count) {
            //     dx = dx * (endTime * 60 - _$Status.other.addTimes);
            //     dy = dy * (endTime * 60 - _$Status.other.addTimes);
            // }
            switch (direct) {
                case 0:
                    //底
                    if (!count) {
                        ctx.translate(0, dy);
                    } else {
                        ctx.translate(0, dy - dy / (endTime * 60) * count);
                    }
                    break;
                case 1:
                    //左
                    if (!count) {
                        ctx.translate(-dx, 0);
                    } else {
                        ctx.translate(-dx + dx / (endTime * 60) * count, 0);
                    }
                    break;
                case 2:
                    //右
                    if (!count) {
                        ctx.translate(dx, 0);
                    } else {
                        ctx.translate(dx - dx / (endTime * 60) * count, 0);
                    }
                    break;
                case 3:
                    //顶
                    if (!count) {
                        ctx.translate(0, -dy);
                    } else {
                        ctx.translate(0, -dy + dy / (endTime * 60) * count);
                    }
                    break;
                case 4:
                    //左下
                    if (!count) {
                        ctx.translate(-dx, dy);
                    } else {
                        ctx.translate(-dx + dx / (endTime * 60) * count, dy - dy / (endTime * 60) * count);
                    }
                    break;
                case 5:
                    //右下
                    if (!count) {
                        ctx.translate(dx, dy);
                    } else {
                        ctx.translate(dx - dx / (endTime * 60) * count, dy - dy / (endTime * 60) * count);
                    }
                    break;
                case 6:
                    //左上
                    if (!count) {
                        ctx.translate(-dx, -dy);
                    } else {
                        ctx.translate(-dx + dx / (endTime * 60) * count, -dy + dy / (endTime * 60) * count);
                    }
                    break;
                case 7:
                    //右上
                    if (!count) {
                        ctx.translate(dx, -dy);
                    } else {
                        ctx.translate(dx - dx / (endTime * 60) * count, -dy + dy / (endTime * 60) * count);
                    }
                    break;
            }
        }

        function in_rise() {
            //进入上升
            let RiseDistance = 100 //距离暂时用100
            if (_$Status.other.addTimes && _$Status.other.addTimes != count) {
                ctx.translate(0, (RiseDistance - RiseDistance / (endTime * 60) * count) * (endTime * 60 - _$Status.other.addTimes));
            }
            ctx.globalAlpha = 1 / (60 * endTime) * count;
            if (!count) {
                ctx.translate(0, RiseDistance);
            } else if (!_$Status.other.addTimes) {
                ctx.translate(0, RiseDistance - RiseDistance / (endTime * 60) * count);
            }
        }

        function in_split() {
            //劈裂
            ctx.beginPath();
            if (textInfo) {
                var infox = textInfo[0],
                    infoy = textInfo[1],
                    infowidth = textInfo[2],
                    infoheight = textInfo[3];
            }
            switch (direct) {
                case 0:
                    //上下向中央
                    if (textInfo) {
                        ctx.rect(infox, infoy, infowidth, infoheight / 2 / (endTime * 60) * count);
                        ctx.rect(infox, infoy + infoheight - infoheight / 2 / (endTime * 60) * count, infowidth, infoheight / 2 / (endTime * 60) * count);
                    } else {
                        ctx.rect(sx - 0.5, sy - 0.5, swidth + 1, sheight / 2 / (endTime * 60) * count + 1);
                        ctx.rect(sx - 0.5, sy + sheight - sheight / 2 / (endTime * 60) * count - 0.5, swidth + 1, sheight / 2 / (endTime * 60) * count + 1);
                    }
                    break;
                case 1:
                    //中央向上下
                    if (textInfo) {
                        ctx.rect(infox, infoy + infoheight / 2 - infoheight / 2 / (endTime * 60) * count, infowidth, infoheight / (endTime * 60) * count);
                    } else {
                        ctx.rect(sx - 0.5, sy + sheight / 2 - sheight / 2 / (endTime * 60) * count - 0.5, swidth + 1, sheight / (endTime * 60) * count + 1);
                    }
                    break;
                case 2:
                    //左右向中央
                    if (textInfo) {
                        ctx.rect(infox, infoy, infowidth / 2 / (endTime * 60) * count, infoheight);
                        ctx.rect(infox + infowidth - infowidth / 2 / (endTime * 60) * count, infoy, infowidth / 2 / (endTime * 60) * count, infoheight);
                    } else {
                        ctx.rect(sx - 0.5, sy - 0.5, swidth / 2 / (endTime * 60) * count + 1, sheight + 1);
                        ctx.rect(sx + swidth - swidth / 2 / (endTime * 60) * count - 0.5, sy - 0.5, swidth / 2 / (endTime * 60) * count + 1, sheight + 1);
                    }
                    break;
                case 3:
                    //中央向左右
                    if (textInfo) {
                        ctx.rect(infox + infowidth / 2 - infowidth / 2 / (endTime * 60) * count, infoy, infowidth / (endTime * 60) * count, infoheight);
                    } else {
                        ctx.rect(sx + swidth / 2 - swidth / 2 / (endTime * 60) * count - 0.5, sy - 0.5, swidth / (endTime * 60) * count + 1, sheight + 1);
                    }
                    break;
            }
            ctx.clip();
        }

        function in_wipe() {
            //擦除
            ctx.beginPath();
            if (textInfo) {
                var infox = textInfo[0],
                    infoy = textInfo[1],
                    infowidth = textInfo[2],
                    infoheight = textInfo[3];
            }
            switch (direct) {
                case 0:
                    //自底
                    if (textInfo) {
                        ctx.rect(infox, infoy + infoheight - infoheight / (endTime * 60) * count, infowidth, infoheight / (endTime * 60) * count);
                    } else {
                        ctx.rect(sx - 0.5, sy + sheight - sheight / (endTime * 60) * count - 0.5, swidth + 1, sheight / (endTime * 60) * count + 1);
                    }
                    break;
                case 1:
                    //自左
                    if (textInfo) {
                        ctx.rect(infox, infoy, infowidth / (endTime * 60) * count, infoheight);
                    } else {
                        ctx.rect(sx - 0.5, sy - 0.5, swidth / (endTime * 60) * count, sheight + 1);
                    }
                    break;
                case 2:
                    //自右
                    if (textInfo) {
                        ctx.rect(infox + infowidth - infowidth / (endTime * 60) * count, infoy, infowidth / (endTime * 60) * count, infoheight);
                    } else {
                        ctx.rect(sx + swidth - swidth / (endTime * 60) * count - 0.5, sy - 0.5, swidth / (endTime * 60) * count + 1, sheight + 1);
                    }
                    break;
                case 3:
                    //自顶
                    if (textInfo) {
                        ctx.rect(infox, infoy, infowidth, infoheight / (endTime * 60) * count);
                    } else {
                        ctx.rect(sx - 0.5, sy - 0.5, swidth + 1, sheight / (endTime * 60) * count + 1);
                    }
                    break;
            }
            ctx.clip();
        }

        function in_circleDevelop() {
            //圆形扩展
            ctx.beginPath();
            if (textInfo) {
                var infox = textInfo[0],
                    infoy = textInfo[1],
                    infowidth = textInfo[2],
                    infoheight = textInfo[3],
                    cx = infox + infowidth / 2,
                    cy = infoy + infoheight / 2,
                    r1 = infowidth / 2,
                    r2 = infoheight / 2;
            }
            switch (direct) {
                case 0:
                    //向内
                    if (textInfo) {
                        ctx.rect(infox - 0.5, infoy - 0.5, infowidth + 0.5, infoheight + 0.5);
                        ctx.clip();
                        ctx.beginPath();
                        ctx.fillStyle = "white";
                        ctx.strokeStyle = "white";
                        // tofix(2)为了解决防止传入的数为负数，BUG号：DCC-5674
                        let a = (r1 * Math.sqrt(2) - r1 * Math.sqrt(2) / (endTime * 60) * count).toFixed(2);
                        let b = (r2 * Math.sqrt(2) - r2 * Math.sqrt(2) / (endTime * 60) * count).toFixed(2);
                        ctx.ellipse(cx, cy, a, b, 0, 0, Math.PI * 2);
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                    } else {
                        ctx.rect(sx - 3.5, sy - 3.5, swidth + 10, sheight + 10);
                        ctx.clip();
                        ctx.beginPath();
                        ctx.fillStyle = "rgb(255, 255, 255)";
                        ctx.strokeStyle = "white";
                        let a = (swidth / 1.8 - swidth / 1.8 / (endTime * 60) * count > 0 ? swidth / 1.8 - swidth / 1.8 / (endTime * 60) * count : 0).toFixed(2);
                        let b = (sheight / 1.8 - sheight / 1.8 / (endTime * 60) * count > 0 ? sheight / 1.8 - sheight / 1.8 / (endTime * 60) * count : 0).toFixed(2);
                        ctx.ellipse(sx + swidth / 2, sy + sheight / 2, a, b, 0, 0, Math.PI * 2);
                        ctx.fill();
                        ctx.stroke();
                        ctx.closePath();
                    }
                    break;
                case 1:
                    //向外
                    if (textInfo) {
                        ctx.ellipse(cx, cy, (r1 * Math.sqrt(2) / (endTime * 60) * count).toFixed(2), (r2 * Math.sqrt(2) / (endTime * 60) * count).toFixed(2), 0, 0, Math.PI * 2);
                    } else {
                        ctx.ellipse(sx + swidth / 2, sy + sheight / 2, (swidth / Math.sqrt(2) / (endTime * 60) * count).toFixed(2), (sheight / Math.sqrt(2) / (endTime * 60) * count).toFixed(2), 0, 0, Math.PI * 2);
                    }
                    ctx.clip();
                    break;
            }
        }

        function in_wheel() {
            //轮子
            ctx.beginPath();
            if (textInfo) {
                var infox = textInfo[0],
                    infoy = textInfo[1],
                    infowidth = textInfo[2],
                    infoheight = textInfo[3],
                    cx = infox + infowidth / 2,
                    cy = infoy + infoheight / 2,
                    r = infoheight >= infowidth ? infoheight : infowidth;
            } else {
                var cx = sx + swidth / 2,
                    cy = sy + sheight / 2,
                    r = swidth >= sheight ? swidth : sheight;
            }
            switch (direct) {
                case 0:
                    //1
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, -Math.PI * 0.5, -Math.PI * 0.5 + 2 * Math.PI / (endTime * 60) * count, false);
                    break;
                case 1:
                    //2
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, -Math.PI * 0.5, -Math.PI * 0.5 + Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.5, Math.PI * 0.5 + Math.PI / (endTime * 60) * count, false);
                    break;
                case 2:
                    //3
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, -Math.PI * 0.5, -Math.PI * 0.5 + 2 / 3 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI / 6, Math.PI / 6 + 2 / 3 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 5 / 6, Math.PI * 5 / 6 + 2 / 3 * Math.PI / (endTime * 60) * count, false);
                    break;
                case 3:
                    //4
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, -Math.PI * 0.5, -Math.PI * 0.5 + 0.5 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0, Math.PI * 0 + 0.5 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.5, Math.PI * 0.5 + 0.5 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1, Math.PI * 1 + 0.5 * Math.PI / (endTime * 60) * count, false);
                    break;
                case 4:
                    //8
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0, Math.PI * 0 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.25, Math.PI * 0.25 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.5, Math.PI * 0.5 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.75, Math.PI * 0.75 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1, Math.PI * 1 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.25, Math.PI * 1.25 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.5, Math.PI * 1.5 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.75, Math.PI * 1.75 + 0.25 * Math.PI / (endTime * 60) * count, false);
                    break;
            }
            ctx.clip();
        }

        function in_linesRandom() {
            //随机线条
            var ranRect = 30
            var posi1 = [0, 8, 4, 5, 2, 9, 3, 6, 7, 1]
            var posi2 = [5, 4, 6, 3, 7, 2, 8, 1, 9, 0]
            var posi3 = [9, 1, 2, 8, 0, 7, 3, 5, 4, 6]
            ctx.beginPath();
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
            } else {
                var bx = sx,
                    by = sy,
                    bw = swidth,
                    bh = sheight;
            }
            switch (direct) {
                case 1:
                    var count0 = Math.floor(count / (endTime * 6));
                    for (let i = 0; i < ranRect; i++) {
                        if (i % 3 == 0) {
                            for (let p = 0; p < count0; p++) {
                                ctx.rect(bx + i * bw / ranRect + (posi1[p] * bw) / (ranRect * 10), by, bw / (ranRect * 10), bh)
                            }
                        } else if (i % 3 == 1) {
                            for (let p = 0; p < count0; p++) {
                                ctx.rect(bx + i * bw / ranRect + (posi2[p] * bw) / (ranRect * 10), by, bw / (ranRect * 10), bh)
                            }
                        } else {
                            for (let p = 0; p < count0; p++) {
                                ctx.rect(bx + i * bw / ranRect + (posi3[p] * bw) / (ranRect * 10), by, bw / (ranRect * 10), bh)
                            }
                        }


                    }
                    break;
                case 0:
                    var count1 = Math.floor(count / (endTime * 6));
                    for (let j = 0; j < ranRect; j++) {
                        if (j % 3 == 0) {
                            for (let t = 0; t < count1; t++) {
                                ctx.rect(bx, by + j * bh / ranRect + (posi1[t] * bh) / (ranRect * 10), bw, bh / (ranRect * 10))
                            }
                        } else if (j % 3 == 1) {
                            for (let t = 0; t < count1; t++) {
                                ctx.rect(bx, by + j * bh / ranRect + (posi2[t] * bh) / (ranRect * 10), bw, bh / (ranRect * 10))
                            }
                        } else {
                            for (let t = 0; t < count1; t++) {
                                ctx.rect(bx, by + j * bh / ranRect + (posi3[t] * bh) / (ranRect * 10), bw, bh / (ranRect * 10))
                            }
                        }


                    }
                    break;
            }
            ctx.clip();
        }

        function in_fadeturn() {
            //翻转式由远及近
            ctx.globalAlpha = 1 / (60 * endTime) * count;
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
            } else {
                var bx = sx,
                    by = sy,
                    bw = swidth,
                    bh = sheight;
            }
            var cx = bx + bw / 2,
                cy = by + bh / 2;
            ctx.translate(cx, cy);
            ctx.rotate(Math.PI / 4 - Math.PI / 4 / (endTime * 60) * count);
            ctx.translate(-cx, -cy);
            ctx.translate(cx * (1 - (1 / (endTime * 60) * count)), cy * (1 - (1 / (endTime * 60) * count)));
            ctx.scale(1 / (endTime * 60) * count, 1 / (endTime * 60) * count);
        }

        function in_fadescale() {
            //渐变式缩放
            ctx.globalAlpha = 1 / (60 * endTime) * count;
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
            } else {
                var bx = sx,
                    by = sy,
                    bw = swidth,
                    bh = sheight;
            }
            var cx = bx + bw / 2,
                cy = by + bh / 2;
            ctx.translate(cx * (1 - (0.5 + 0.5 / (endTime * 60) * count)), cy * (1 - (0.5 + 0.5 / (endTime * 60) * count)));
            ctx.scale(0.5 + 0.5 / (endTime * 60) * count, 0.5 + 0.5 / (endTime * 60) * count);
        }

        function in_faderound() {
            //渐变式回旋
            ctx.globalAlpha = 1 / (60 * endTime) * count;

            var cx, cy;
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
                cx = bx + bw / 2;
                cy = by + bh / 2;
            } else {
                cx = getCenterPoint(shape).x;
                cy = getCenterPoint(shape).y;
            }
            // 旋转两次的效果
            // if (count <= 30 * endTime) {
            //     ctx.transform(1 - 2 / (30 * endTime) * count, 0, 0, 1, cx * (1 - (1 - 2 / (30 * endTime) * count)), 0);
            // } else {
            //     ctx.transform(-1 + 2 / (30 * endTime) * (count - 30 * endTime), 0, 0, 1, cx * (1 - (-1 + 2 / (30 * endTime) * (count - 30 * endTime))), 0);
            // }

            // 为了改成旋转三次的效果
            if (0 < count && count <= 20 * endTime) {
                count = (20 * endTime) - count
            } else if (20 * endTime < count && count <= 40 * endTime) {
                count = count - (20 * endTime)
            } else if (40 * endTime < count && count <= 60 * endTime) {
                count = (60 * endTime) - count
            }
            ctx.transform(1 - 2 / (20 * endTime) * count, 0, 0, 1, cx * (1 - (1 - 2 / (20 * endTime) * count)), 0);
        }

        function in_jump() {
            //弹跳
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            var cx = dx + dw / 2,
                cy = dy + dh / 2,
                dirattr = direct[1].pathPoints,
                pathPoints = [];
            for (let len = 0; len < dirattr.length; len++) {
                pathPoints.push([dirattr[len], dirattr[len + 1]]);
                len++;
            }
            var plen = pathPoints.length,
                oncecount = plen / (endTime * 60),
                num = Math.floor(oncecount * count),
                floatNum = oncecount * count - num;
            if (oncecount * count < plen && num < plen - 1) {
                var strPoint = [pathPoints[num][0], pathPoints[num][1]],
                    endPoint = [pathPoints[num + 1][0], pathPoints[num + 1][1]];
                ctx.translate(strPoint[0]/3 + (endPoint[0] - strPoint[0]) * floatNum, strPoint[1]/3 + (endPoint[1] - strPoint[1]) * floatNum);
                if (count > 1 && num < plen - 1) {
                    if (pathPoints[num][1] >= pathPoints[num + 1][1] && pathPoints[num][1] >= pathPoints[num - 1][1]) {
                        ctx.translate(0, cy * 0.2);
                        ctx.scale(1, 0.8);
                    }
                }
            } else {
                ctx.translate(0, 0);
            }
        }

        function in_down() {
            //微软向下浮动
            if (_$Status.other.addTimes && _$Status.other.addTimes != count) {
                ctx.translate(0, (-250 + 250 / (endTime * 60) * count) * (endTime * 60 - _$Status.other.addTimes));
            }
            ctx.globalAlpha = 1 / (60 * endTime) * count;
            if (!count) {
                ctx.translate(0, -250); //距离暂时用250
            } else if (!_$Status.other.addTimes) {
                ctx.translate(0, -250 + 250 / (endTime * 60) * count);
            }
        }

        function in_slowmove() {
            // wps 渐入
            let distance = 250; //距离暂时用250
            ctx.translate(-distance + distance / (endTime * 60) * count, 0);
            ctx.beginPath();
            ctx.rect(sx + swidth - swidth / (endTime * 60) * count, sy, (endTime * 60) * count, sheight);
            ctx.clip()
        }

        function in_scale() {
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
            } else {
                var bx = sx,
                    by = sy,
                    bw = swidth,
                    bh = sheight;
            }
            var cx = bx + bw / 2,
                cy = by + bh / 2,
                w = ctx.canvas.width / 2.5 - bx - bw / 2,
                h = ctx.canvas.height / 3 - by - bh / 2;
            switch (direct) {
                // 内扩
                case 0:
                    ctx.translate(cx * (1 - (0.5 + 0.5 / (endTime * 60) * count)), cy * (1 - (0.5 + 0.5 / (endTime * 60) * count)));
                    ctx.scale(0.5 + 0.5 / (endTime * 60) * count, 0.5 + 0.5 / (endTime * 60) * count);
                    break
                // 屏幕中心扩
                case 1:
                    ctx.translate(w * (1 - (0.3 + 0.7 / (endTime * 60) * count)), h * (1 - (0.3 + 0.7 / (endTime * 60) * count)));
                    ctx.scale(0.3 + 0.7 / (endTime * 60) * count, 0.3 + 0.7 / (endTime * 60) * count);
                    break
                // 轻微放大
                case 2:
                    ctx.translate(cx * (1 - (0.8 + 0.2 / (endTime * 60) * count)), (by + bh) * (1 - (0.8 + 0.2 / (endTime * 60) * count)));
                    ctx.scale(0.8 + 0.2 / (endTime * 60) * count, 0.8 + 0.2 / (endTime * 60) * count);
                    break
                // 外缩
                case 3:
                    ctx.translate(cx * (-1 + 1 / (endTime * 60) * count), cy * (-1 + 1 / (endTime * 60) * count));
                    ctx.scale(2 - 1 / (endTime * 60) * count, 2 - 1 / (endTime * 60) * count);
                    break
                // 从底部缩小
                case 4:
                    ctx.translate(0 - cx * (1 - 1 / (endTime * 60) * count), h * (1 - 1 / (endTime * 60) * count));
                    ctx.scale(2 - 1 / (endTime * 60) * count, 2 - 1 / (endTime * 60) * count);
                    break
                case 5:
                    ctx.translate(cx * (-0.2 + 0.2 / (endTime * 60) * count), cy * (-0.2 + 0.2 / (endTime * 60) * count));
                    ctx.scale(1.2 - 0.2 / (endTime * 60) * count, 1.2 - 0.2 / (endTime * 60) * count);
                    break;
            }
        }

        function in_box() {
            // 盒装
            ctx.beginPath();
            if (textInfo) {
                var infox = textInfo[0],
                    infoy = textInfo[1],
                    infowidth = textInfo[2],
                    infoheight = textInfo[3];
            }
            switch (direct) {
                case 0:
                    // 向内
                    if (textInfo) { // 上 下 左 右
                        ctx.rect(infox, infoy, infowidth, infoheight / 2 / (endTime * 60) * count);
                        ctx.rect(infox, infoy + infoheight - infoheight / 2 / (endTime * 60) * count, infowidth, infoheight / 2 / (endTime * 60) * count);
                        ctx.rect(infox, infoy, infowidth / 2 / (endTime * 60) * count, infoheight);
                        ctx.rect(infox + infowidth - infowidth / 2 / (endTime * 60) * count, infoy, infowidth / 2 / (endTime * 60) * count, infoheight);
                    } else {
                        ctx.rect(sx - 0.5, sy - 0.5, swidth + 1, sheight / 2 / (endTime * 60) * count + 1);
                        ctx.rect(sx - 0.5, sy + sheight - sheight / 2 / (endTime * 60) * count - 0.5, swidth + 1, sheight / 2 / (endTime * 60) * count + 1);
                        ctx.rect(sx - 0.5, sy - 0.5, swidth / 2 / (endTime * 60) * count + 1, sheight + 1);
                        ctx.rect(sx + swidth - swidth / 2 / (endTime * 60) * count - 0.5, sy - 0.5, swidth / 2 / (endTime * 60) * count + 1, sheight + 1);
                    }
                    break
                case 1:
                    // 向外
                    if (textInfo) {
                        ctx.rect(infox + infowidth / 2 * (1 - 1 / (endTime * 60) * count), infoy + infoheight / 2 * (1 - 1 / (endTime * 60) * count), infowidth / (endTime * 60) * count, infoheight / (endTime * 60) * count)
                    } else {
                        ctx.rect(sx + swidth / 2 * (1 - 1 / (endTime * 60) * count), sy + sheight / 2 * (1 - 1 / (endTime * 60) * count), swidth / (endTime * 60) * count, sheight / (endTime * 60) * count)
                    }
                    break
            }
            ctx.clip()

        }

        function in_step() {
            // 阶梯状 左下，左上，右下， 右上
            let step = Math.floor(count / (endTime * 3))
            ctx.beginPath()
            switch (direct) {
                case 2: //右下
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + i * swidth / 20, sy, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + j * swidth / 20, sy, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
                case 0: // 左下
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + swidth - i * swidth / 20, sy, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + swidth - j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + swidth - j * swidth / 20, sy, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
                case 3: //右上
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + i * swidth / 20, sy + sheight - (2 * step - i) * sheight / 20, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + j * swidth / 20, sy + sheight * (j + 20 - 2 * step) / 20, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
                case 1: // 左上
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + swidth - i * swidth / 20, sy + sheight - (2 * step - i) * sheight / 20, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + swidth - j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + swidth - j * swidth / 20, sy + sheight * (j + 20 - 2 * step) / 20, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
            }
            ctx.clip()
        }

        function in_cross() {
            // 十字形
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 内
                    ctx.rect(sx, sy, swidth / (endTime * 120) * count, sheight / (endTime * 120) * count)
                    ctx.rect(sx + swidth - swidth / (endTime * 120) * count, sy, swidth / (endTime * 120) * count, sheight / (endTime * 120) * count)
                    ctx.rect(sx, sy + sheight - sheight / (endTime * 120) * count, swidth / (endTime * 120) * count, sheight / (endTime * 120) * count)
                    ctx.rect(sx + swidth - swidth / (endTime * 120) * count, sy + sheight - sheight / (endTime * 120) * count, swidth / (endTime * 120) * count, sheight / (endTime * 120) * count)
                    break
                case 1:
                    // 外
                    ctx.rect(sx, sy + sheight / 2 - sheight / (endTime * 120) * count, swidth, sheight / (endTime * 60) * count)
                    ctx.rect(sx + swidth / 2 - swidth / (endTime * 120) * count, sy, swidth / (endTime * 60) * count, sheight)
                    break
            }
            ctx.clip()
        }

        function in_cut() {
            // 切入
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 下
                    ctx.translate(0, sheight - sheight / (endTime * 60) * count)
                    ctx.rect(sx, sy, swidth, sheight / (endTime * 60) * count)
                    break
                case 1:
                    // 左
                    ctx.translate(swidth / (endTime * 60) * count - swidth, 0)
                    ctx.rect(sx + swidth - swidth / (endTime * 60) * count, sy, swidth / (endTime * 60) * count, sheight)
                    break
                case 2:
                    // 右
                    ctx.translate(swidth - swidth / (endTime * 60) * count, 0)
                    ctx.rect(sx, sy, swidth / (endTime * 60) * count, sheight)
                    break
                case 3:
                    // 上
                    ctx.translate(0, sheight / (endTime * 60) * count - sheight)
                    ctx.rect(sx, sy + sheight - sheight / (endTime * 60) * count, swidth, sheight / (endTime * 60) * count)
                    break
            }
            ctx.clip()
        }

        function in_square() {
            ctx.beginPath()
            switch (direct) {
                case 1:
                    ctx.moveTo(sx + swidth / 2 - swidth / (endTime * 60) * count, sy + sheight / 2)
                    ctx.lineTo(sx + swidth / 2, sy + sheight / 2 - sheight / (endTime * 60) * count)
                    ctx.lineTo(sx + swidth - swidth / 2 + swidth / (endTime * 60) * count, sy + sheight / 2)
                    ctx.lineTo(sx + swidth / 2, sy + sheight - sheight / 2 + sheight / (endTime * 60) * count)
                    ctx.lineTo(sx + swidth / 2 - swidth / (endTime * 60) * count, sy + sheight / 2)
                    ctx.closePath()
                    break
                case 0:
                    if (count / (endTime * 60) < 0.5) {
                        ctx.moveTo(sx, sy)
                        ctx.lineTo(sx + swidth / (endTime * 60) * count, sy)
                        ctx.lineTo(sx, sy + sheight / (endTime * 60) * count)
                        ctx.lineTo(sx, sy)
                        ctx.closePath()
                        ctx.moveTo(sx + swidth, sy)
                        ctx.lineTo(sx + swidth - swidth / (endTime * 60) * count, sy)
                        ctx.lineTo(sx + swidth, sy + sheight / (endTime * 60) * count)
                        ctx.lineTo(sx + swidth, sy)
                        ctx.closePath()
                        ctx.moveTo(sx, sy + sheight)
                        ctx.lineTo(sx, sy + sheight - sheight / (endTime * 60) * count)
                        ctx.lineTo(sx + swidth / (endTime * 60) * count, sy + sheight)
                        ctx.lineTo(sx, sy + sheight)
                        ctx.closePath()
                        ctx.moveTo(sx + swidth, sy + sheight)
                        ctx.lineTo(sx + swidth, sy + sheight - sheight / (endTime * 60) * count)
                        ctx.lineTo(sx + swidth - swidth / (endTime * 60) * count, sy + sheight)
                        ctx.lineTo(sx + swidth, sy + sheight)
                        ctx.closePath()
                    } else {
                        ctx.moveTo(sx, sy)
                        ctx.lineTo(sx, sy + sheight)
                        ctx.lineTo(sx + swidth, sy + sheight)
                        ctx.lineTo(sx + swidth, sy)
                        ctx.lineTo(sx, sy)
                        ctx.moveTo(sx + swidth / 2, sy - sheight / 2 + sheight / (endTime * 60) * count)
                        ctx.lineTo(sx + swidth * 1.5 - swidth / (endTime * 60) * count, sy + sheight / 2)
                        ctx.lineTo(sx + swidth / 2, sy + sheight * 1.5 - sheight / (endTime * 60) * count)
                        ctx.lineTo(sx - swidth / 2 + swidth / (endTime * 60) * count, sy + sheight / 2)
                        ctx.lineTo(sx + swidth / 2, sy - sheight / 2 + sheight / (endTime * 60) * count)
                        ctx.closePath()
                    }
                    break
            }
            ctx.clip()
        }

        function winkle_once() {
            if (count === endTime * 60) {
                ctx.globalAlpha = 0;
            }
        }

        function in_windowshade() {
            //百叶窗
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 水平
                    for (let i = 0; i <= 5; i++) {
                        ctx.rect(sx, sy + sheight / 6 * i, swidth, sheight / 6 / (endTime * 60) * count)
                    }
                    break
                case 1:
                    // 垂直
                    for (let i = 0; i <= 5; i++) {
                        ctx.rect(sx + swidth / 6 * i, sy, swidth / 6 / (endTime * 60) * count, sheight)
                    }
                    break
            }
            ctx.clip()
        }

        function in_langsam() {
            // 缓慢进入
            ctx.beginPath()
            let dis
            switch (direct) {
                case 0:
                    // 下
                    dis = 700 - sy
                    ctx.translate(0, dis - dis / (endTime * 60) * count)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
                case 1:
                    // 左
                    dis = sx + swidth
                    ctx.translate(dis / (endTime * 60) * count - dis, 0)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
                case 2:
                    // 右
                    dis = 900 - sx
                    ctx.translate(dis - dis / (endTime * 60) * count, 0)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
                case 3:
                    // 上
                    dis = sy + sheight
                    ctx.translate(0, dis / (endTime * 60) * count - dis)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
            }
            ctx.clip()
        }

        function in_schachbrett() {
            // 棋盘
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 跨越
                    for (let i = 0; i <= 11; i++) {
                        for (let j = 0; j <= 5; j++) {
                            if ((i + j) % 2 == 0) {
                                if (endTime * 30 - count > 0) {
                                    ctx.rect(sx + swidth / 12 * i, sy + sheight / 6 * j, swidth / 12 / (endTime * 30) * count, sheight / 6)
                                } else {
                                    ctx.rect(sx + swidth / 12 * i, sy + sheight / 6 * j, swidth / 12, sheight / 6)
                                }
                            } else {
                                if (endTime * 30 - count < 0) {
                                    ctx.rect(sx + swidth / 12 * i, sy + sheight / 6 * j, swidth / 12 / (endTime * 30) * (count - endTime * 30), sheight / 6)
                                }
                            }
                        }
                    }
                    break
                case 1:
                    // 下
                    for (let i = 0; i <= 5; i++) {
                        for (let j = 0; j <= 11; j++) {
                            if ((i + j) % 2 == 0) {
                                if (endTime * 30 - count > 0) {
                                    ctx.rect(sx + swidth / 6 * i, sy + sheight / 12 * j, swidth / 6, sheight / 12 / (endTime * 30) * count)
                                } else {
                                    ctx.rect(sx + swidth / 6 * i, sy + sheight / 12 * j, swidth / 6, sheight / 12)
                                }
                            } else {
                                if (endTime * 30 - count < 0) {
                                    ctx.rect(sx + swidth / 6 * i, sy + sheight / 12 * j, swidth / 6, sheight / 12 / (endTime * 30) * (count - endTime * 30))
                                }
                            }
                        }
                    }
                    break
            }
            ctx.clip()
        }

        function in_sector() {
            // 扇形
            const bx = sx + swidth / 2
            const by = sy + sheight / 2
            ctx.beginPath()
            ctx.moveTo(bx, by)
            ctx.arc(bx, by, (sheight + swidth) / 2, -Math.PI * 0.5 - Math.PI / (endTime * 60) * count, -Math.PI * 0.5 + Math.PI / (endTime * 60) * count);
            ctx.closePath()
            ctx.clip()
        }

        function in_loesung() {
            let step = Math.floor(count / (endTime * 3))
            let w = Math.floor(swidth / 60) + 1
            let h = Math.floor(sheight / 20) + 1
            // 向内溶解
            ctx.beginPath()
            for (let i = 0; i < w; i++) {
                for (let j = 0; j < h; j++) {
                    for (let k = 1; k <= step; k++) {
                        switch (k) {
                            case 1:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 2:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 3:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 4:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 5:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 6:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 7:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 8:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 9:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 10:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 11:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 12:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 13:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 14:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 15:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 16:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 17:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 18:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 19:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 20:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                        }
                    }
                }
            }
            ctx.clip()
        }

        function in_random() {
            let randomNum;
            if (!self.randomNum) {
                let minNum = 0;
                let maxNum = self.randomList.length - 1;
                randomNum = self.randomNum = self.randomList[Math.floor(Math.random() * (maxNum - minNum)) + minNum];
            } else {
                randomNum = self.randomNum
            }
            self.animHandler(_$Status, shape, ctx, count, randomNum, animType, endTime, direct, emphAttr, slide, textInfo, oldParaIdx, paraIdx)
            if (count === (60 * endTime) * count) self.randomNum = undefined
        }

        function in_offnen() {
            // 展开
            ctx.globalAlpha = 1 / (60 * endTime) * count;
            ctx.translate((0.5 - 0.5 / (endTime * 60) * count) * (sx + swidth / 2), 0)
            ctx.scale(0.5 + 0.5 / (endTime * 60) * count, 1);
        }

        function in_open() {
            // 横展开
            ctx.globalAlpha = 1 / (60 * endTime) * count;
            ctx.translate((0.5 / (endTime * 60) * count - 0.5) * swidth, 0)
        }

        function empha_fadescale() {
            //强调忽明忽暗
            if (textInfo) {
                ctx.globalAlpha = count <= 30 * endTime ? 1 - 1.8 / (60 * endTime) * count : 0.1 + 0.9 / (60 * endTime) * count;
                ctx.translate(textInfo[0] * (1 - (count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count))), textInfo[1] * (1 - (count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count))));
                ctx.scale(count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count), count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count));
            } else {
                ctx.globalAlpha = count <= 30 * endTime ? 1 - 1.8 / (60 * endTime) * count : 0.1 + 0.9 / (60 * endTime) * count;
                ctx.translate(getCenterPoint(shape).x * (1 - (count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count))), getCenterPoint(shape).y * (1 - (count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count))));
                ctx.scale(count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count), count <= 30 * endTime ? 1 + 1 / 90 * count : 1 + 1 / 90 * (60 * endTime - count));
            }
        }

        function empha_twinkle() {
            //强调闪动
            if (!fillColor && shapeType == 202) {
                ctx.globalAlpha = count <= endTime * 30 ? 1 - 1 / (endTime * 30) * count : count <= endTime * 50 ? 0.5 / (20 * endTime) * (count - 30 * endTime) : 0.5 - 0.5 / (20 * endTime) * (count - 50 * endTime);
            } else {
                ctx.globalAlpha = count <= endTime * 30 ? 1 - 1 / (endTime * 30) * count : 1 / (endTime * 30) * (count - 30 * endTime);
            }
            if (emphAttr && count < endTime * 60) {
                ctx.fillStyle = `rgb(${emphAttr.r},${emphAttr.g},${emphAttr.b})`
                if (oldParaIdx <= 0) {
                    ctx.strokeStyle = '#000001'
                } else {
                    ctx.strokeStyle = '#000002'
                }
            }
        }

        function empha_rotateborder() {
            //强调跷跷板
            if (textInfo) {
                ctx.translate(textInfo[0] + textInfo[2] / 2, textInfo[1] + textInfo[3] / 2);
            } else {
                ctx.translate(getCenterPoint(shape).x, getCenterPoint(shape).y);
            }
            if (count <= endTime * 60 / 8) {
                ctx.rotate(-Math.PI / 45 / (endTime * 60 / 8) * count);
            } else if (count > endTime * 60 / 8 && count <= endTime * 60 * 3 / 8) {
                ctx.rotate(-Math.PI / 45 + Math.PI / 45 / (endTime * 60 / 4) * (count - endTime * 60 / 8));
            } else if (count > endTime * 60 * 3 / 8 && count <= endTime * 60 * 5 / 8) {
                ctx.rotate(Math.PI / 45 - Math.PI / 45 / (endTime * 60 / 4) * (count - endTime * 60 * 3 / 8));
            } else if (count > endTime * 60 * 5 / 8 && count <= endTime * 60 * 7 / 8) {
                ctx.rotate(-Math.PI / 45 + Math.PI / 45 / (endTime * 60 / 4) * (count - endTime * 60 * 5 / 8));
            } else {
                ctx.rotate(Math.PI / 45 - Math.PI / 45 / (endTime * 60 / 8) * (count - endTime * 60 * 7 / 8));
            }
            if (textInfo) {
                ctx.translate(-textInfo[0] - textInfo[2] / 2, -textInfo[1] - textInfo[3] / 2);
            } else {
                ctx.translate(-getCenterPoint(shape).x, -getCenterPoint(shape).y);
            }
        }

        function empha_rotate() {
            //强调陀螺旋
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            var cx = dx + dw / 2,
                cy = dy + dh / 2,
                dir = direct[0],
                dirattr = direct[1];
            ctx.translate(cx, cy);
            switch (dir) {
                case 0:
                    //顺时针
                    ctx.rotate(Math.PI * (dirattr / 180) / (endTime * 60) * count);
                    break;
                case 1:
                    //逆时针
                    ctx.rotate(-Math.PI * (dirattr / 180) / (endTime * 60) * count);
                    break;
            }
            ctx.translate(-cx, -cy);
        }

        function empha_scale() {
            //强调放大缩小
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            var cx = dx + dw / 2,
                cy = dy + dh / 2,
                dir = direct[0],
                dirattr = direct[1],
                lastAttr = direct[2] || 1;    // fix连续缩放bug，用于记录上一次的缩放比 2021.11.03
            switch (dir) {
                case 0:
                    //水平
                    ctx.translate(cx - cx * lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count), 0);
                    ctx.scale(lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count), 1);
                    break;
                case 1:
                    //垂直
                    ctx.translate(0, cy - cy * lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count));
                    ctx.scale(1, lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count));
                    break;
                case 2:
                    //两者
                    ctx.translate(cx - cx * lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count), cy - cy * lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count));
                    ctx.scale(lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count), lastAttr * (1 - (1 - dirattr) / (endTime * 60) * count));
                    break;
            }
        }

        function empha_unsaturated() {//不饱和
            // 起始颜色 rgb(br, bg, bb) 结束颜色 rgb(fr, fg, fb)
            let { br, bg, bb, fr, fb, fg } = emphAttr
            let g = Math.floor((bg - fg) / (60 * endTime) * count + fg),
                r = Math.floor((br - fr) / (60 * endTime) * count + fr),
                b = Math.floor((bb - fb) / (60 * endTime) * count + fb)
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            if (paraIdx < 0) {
                ctx.strokeStyle = `#000001`
            } else {
                ctx.strokeStyle = `#000002`
            }
        }

        function empha_deepen() {//加深
            let { br, bg, bb, fr, fb, fg } = emphAttr
            let g = Math.floor((bg - fg) / (60 * endTime) * count + fg),
                r = Math.floor((br - fr) / (60 * endTime) * count + fr),
                b = Math.floor((bb - fb) / (60 * endTime) * count + fb)
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            if (paraIdx < 0) {
                ctx.strokeStyle = `#000002`
            } else {
                ctx.strokeStyle = `#000001`
            }
        }

        function empha_shallow() {//变浅
            let { br, bg, bb, fr, fb, fg } = emphAttr
            let g = Math.floor((bg - fg) / (60 * endTime) * count + fg),
                r = Math.floor((br - fr) / (60 * endTime) * count + fr),
                b = Math.floor((bb - fb) / (60 * endTime) * count + fb)
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            if (paraIdx < 0) {
                ctx.strokeStyle = `#000002`
            } else {
                ctx.strokeStyle = `#000001`
            }
        }

        function empha_transparent() {//透明
            if (direct[1] >= 1) {
                direct[1] = 1;
            }
            ctx.globalAlpha = 1 - direct[1] / (60 * endTime) * count;
        }

        function empha_colormix() {//混色
            let { br, bg, bb, fr, fb, fg } = emphAttr
            let g = Math.floor((bg - fg) / (60 * endTime) * count + fg),
                r = Math.floor((br - fr) / (60 * endTime) * count + fr),
                b = Math.floor((bb - fb) / (60 * endTime) * count + fb)
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            if (paraIdx < 0) {
                ctx.strokeStyle = `#000002`
            } else {
                ctx.strokeStyle = `#000001`
            }
        }

        function empha_colorrepair() {//补色
            let { br, bg, bb, fr, fb, fg } = emphAttr
            let g = Math.floor((bg - fg) / (60 * endTime) * count + fg),
                r = Math.floor((br - fr) / (60 * endTime) * count + fr),
                b = Math.floor((bb - fb) / (60 * endTime) * count + fb)
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            if (paraIdx < 0) {
                ctx.strokeStyle = `#000002`
            } else {
                ctx.strokeStyle = `#000001`
            }
        }

        function empha_changeFillColor() {
            let { r, g, b } = emphAttr
            ctx.globalAlpha = 1/(endTime*60)*count
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            ctx.fillRect(shapeRect.x, shapeRect.y, shapeRect.width, shapeRect.height)
            // ctx.strokeStyle = `#00000a`
        }

        function empha_changeLineColor() {
            let { r, g, b } = emphAttr
            ctx.fillStyle = `rgb(${r}, ${g}, ${b})`
            ctx.strokeStyle = '#00000b'
        }

        function boldtwinkle() {//加粗闪烁
            if (count < (endTime * 60) * 0.6 && count > endTime * 60 * 0.5) {
                ctx.strokeStyle = '#000004'
            } else {
                ctx.strokeStyle = '#000000'
            }
            // ctx.globalAlpha = count <= endTime * 30 ? 1 - 1 / (endTime * 30) * count : 1 / (endTime * 30) * (count - 30 * endTime);
        }

        function out_disappear() {
            //退出消失
            ctx.globalAlpha = 0;
        }

        function out_fade() {
            //退出渐变
            ctx.globalAlpha = 1 - 1 / (60 * endTime) * count;
        }

        function out_flyer() {
            //退出飞出
            if (count == 0) {
                sxy = getDistance();
                _$Status.other.animDis = sxy;
            }
            var dx = sxy[0],
                dy = sxy[1];
            if (_$Status.other.addTimes && _$Status.other.addTimes != count) {
                dx = -dx * _$Status.other.addTimes;
                dy = -dy * _$Status.other.addTimes;
            }
            if (count == endTime * 60 && !_$Status.other.addTimes) {
                dx = -dx * count;
                dy = -dy * count;
            }
            switch (direct) {
                case 0:
                    //底
                    ctx.translate(0, dy / (endTime * 60) * count);
                    break;
                case 1:
                    //左
                    ctx.translate(-dx / (endTime * 60) * count, 0);
                    break;
                case 2:
                    //右
                    ctx.translate(dx / (endTime * 60) * count, 0);
                    break;
                case 3:
                    //顶
                    ctx.translate(0, -dy / (endTime * 60) * count);
                    break;
                case 4:
                    //左下
                    ctx.translate(-dx / (endTime * 60) * count, dy / (endTime * 60) * count);
                    break;
                case 5:
                    //右下
                    ctx.translate(dx / (endTime * 60) * count, dy / (endTime * 60) * count);
                    break;
                case 6:
                    //左上
                    ctx.translate(-dx / (endTime * 60) * count, -dy / (endTime * 60) * count);
                    break;
                case 7:
                    //右上
                    ctx.translate(dx / (endTime * 60) * count, -dy / (endTime * 60) * count);
                    break;
            }
        }

        function out_fall() {
            //退出下降
            ctx.globalAlpha = 1 - 1 / (60 * endTime) * count;
            if (_$Status.other.addTimes && _$Status.other.addTimes != count) {
                ctx.translate(0, -250 / (endTime * 60) * _$Status.other.addTimes);
            }
            if (count == endTime * 60 && !_$Status.other.addTimes) {
                ctx.translate(0, -250);
            }
            !_$Status.other.addTimes && ctx.translate(0, 250 / (endTime * 60) * count);
        }

        function out_rise() {
            // 退出上升
            ctx.globalAlpha = 1 - 1 / (60 * endTime) * count;
            if (_$Status.other.addTimes && _$Status.other.addTimes != count) {
                ctx.translate(0, -100 / (endTime * 60) * _$Status.other.addTimes);
            }
            if (count == endTime * 60 && !_$Status.other.addTimes) {
                ctx.translate(0, -100);
            }
            !_$Status.other.addTimes && ctx.translate(0, -50 / (endTime * 60) * count);
        }

        function out_split() {
            //退出劈裂
            ctx.beginPath();
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            count = endTime * 60 - count;
            switch (direct) {
                case 1:
                    //上下向中
                    ctx.rect(dx - 0.5, dy - 0.5, dw + 1, dh / 2 / (endTime * 60) * count + 0.001);
                    ctx.rect(dx - 0.5, dy + dh - dh / 2 / (endTime * 60) * count - 0.5, dw + 1, dh / 2 / (endTime * 60) * count + 0.001);
                    break;
                case 0:
                    //中向上下
                    ctx.rect(dx - 0.5, dy + dh / 2 - dh / 2 / (endTime * 60) * count, dw + 1, dh / (endTime * 60) * count + 0.001);
                    break;
                case 3:
                    //左右向中
                    ctx.rect(dx + 0.5, dy - 0.5, dw / 2 / (endTime * 60) * count + 0.001, dh + 1);
                    ctx.rect(dx + dw - dw / 2 / (endTime * 60) * count - 0.5, dy - 0.5, dw / 2 / (endTime * 60) * count + 0.001, dh + 1);
                    break;
                case 2:
                    //中向左右
                    ctx.rect(dx + dw / 2 - dw / 2 / (endTime * 60) * count, dy - 0.5, dw / (endTime * 60) * count + 0.001, dh + 1);
                    break;
            }
            ctx.clip();
        }

        function out_wipe() {
            //退出擦除
            ctx.beginPath();
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            count = endTime * 60 - count;
            switch (direct) {
                case 3:
                    //自底
                    ctx.rect(dx - 0.5, dy + dh - dh / (endTime * 60) * count + 1, dw + 1, dh / (endTime * 60) * count + 1);
                    break;
                case 2:
                    //自左
                    ctx.rect(dx - 0.5, dy - 0.5, dw / (endTime * 60) * count - 1, dh + 1);
                    break;
                case 1:
                    //自右
                    ctx.rect(dx + dw - dw / (endTime * 60) * count - 0.5, dy - 0.5, dw / (endTime * 60) * count, dh + 1);
                    break;
                case 0:
                    //自顶
                    ctx.rect(dx - 0.5, dy - 1.5, dw + 1, dh / (endTime * 60) * count);
                    break;
            }
            ctx.clip();
        }

        function out_circledevelopment() {
            //退出圆形扩展
            ctx.beginPath();
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            var cx = dx + dw / 2,
                cy = dy + dh / 2,
                r1 = dw / Math.sqrt(2),
                r2 = dh / Math.sqrt(2);
            ctx.rect(dx - 0.5, dy - 0.5, dw + 1, dh + 1);
            ctx.clip();
            switch (direct) {
                case 0:
                    //向内
                    ctx.beginPath();
                    ctx.ellipse(cx, cy, r1 - r1 / (endTime * 60) * count, r2 - r2 / (endTime * 60) * count, 0, 0, Math.PI * 2);
                    ctx.clip();
                    break;
                case 1:
                    //向外
                    ctx.beginPath();
                    ctx.fillStyle = "white";
                    ctx.strokeStyle = "white";
                    ctx.ellipse(cx, cy, r1 / (endTime * 60) * count, r2 / (endTime * 60) * count, 0, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.stroke();
                    ctx.closePath();
                    break;
            }
        }

        function out_wheel() {
            //退出轮子
            ctx.beginPath();
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            var cx = dx + dw / 2,
                cy = dy + dh / 2,
                r = dw > dh ? dw : dh;
            count = endTime * 60 - count;
            switch (direct) {
                case 0:
                    //1
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.5, Math.PI * 1.5 - 2 * Math.PI / (endTime * 60) * count, true);
                    break;
                case 1:
                    //2
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.5, Math.PI * 0.5 - Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.5, Math.PI * 1.5 - Math.PI / (endTime * 60) * count, true);
                    break;
                case 2:
                    //3
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI / 6, Math.PI / 6 - 2 / 3 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 5 / 6, Math.PI * 5 / 6 - 2 / 3 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.5, Math.PI * 1.5 - 2 / 3 * Math.PI / (endTime * 60) * count, true);
                    break;
                case 3:
                    //4
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0, Math.PI * 0 - 0.5 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.5, Math.PI * 0.5 - 0.5 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1, Math.PI * 1 - 0.5 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.5, Math.PI * 1.5 - 0.5 * Math.PI / (endTime * 60) * count, true);
                    break;
                case 4:
                    //8
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.25, Math.PI * 0.25 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.5, Math.PI * 0.5 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 0.75, Math.PI * 0.75 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1, Math.PI * 1 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.25, Math.PI * 1.25 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.5, Math.PI * 1.5 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 1.75, Math.PI * 1.75 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, Math.PI * 2, Math.PI * 2 - 0.25 * Math.PI / (endTime * 60) * count, true);
                    break;
            }
            ctx.clip();
        }

        function out_linesrandom() {
            //随机线条
            var ranRect = 30
            var posi1 = [0, 8, 4, 5, 2, 9, 3, 6, 7, 1]
            var posi2 = [5, 4, 6, 3, 7, 2, 8, 1, 9, 0]
            var posi3 = [9, 1, 2, 8, 0, 7, 3, 5, 4, 6]
            ctx.beginPath();
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
            } else {
                var bx = sx,
                    by = sy,
                    bw = swidth,
                    bh = sheight;
            }
            switch (direct) {
                case 1:
                    var count0 = 10 - Math.floor(count / (endTime * 6));
                    for (let i = 0; i < ranRect; i++) {
                        if (i % 3 == 0) {
                            for (let p = 0; p < count0; p++) {
                                ctx.rect(bx + i * bw / ranRect + (posi1[p] * bw) / (ranRect * 10), by, bw / (ranRect * 10), bh)
                            }
                        } else if (i % 3 == 1) {
                            for (let p = 0; p < count0; p++) {
                                ctx.rect(bx + i * bw / ranRect + (posi2[p] * bw) / (ranRect * 10), by, bw / (ranRect * 10), bh)
                            }
                        } else {
                            for (let p = 0; p < count0; p++) {
                                ctx.rect(bx + i * bw / ranRect + (posi3[p] * bw) / (ranRect * 10), by, bw / (ranRect * 10), bh)
                            }
                        }


                    }
                    break;
                case 0:
                    var count1 = 10 - Math.floor(count / (endTime * 6));
                    for (let j = 0; j < ranRect; j++) {
                        if (j % 3 == 0) {
                            for (let t = 0; t < count1; t++) {
                                ctx.rect(bx, by + j * bh / ranRect + (posi1[t] * bh) / (ranRect * 10), bw, bh / (ranRect * 10))
                            }
                        } else if (j % 3 == 1) {
                            for (let t = 0; t < count1; t++) {
                                ctx.rect(bx, by + j * bh / ranRect + (posi2[t] * bh) / (ranRect * 10), bw, bh / (ranRect * 10))
                            }
                        } else {
                            for (let t = 0; t < count1; t++) {
                                ctx.rect(bx, by + j * bh / ranRect + (posi3[t] * bh) / (ranRect * 10), bw, bh / (ranRect * 10))
                            }
                        }


                    }
                    break;
            }
            ctx.clip();
        }

        function out_fadescale() {
            //退出渐变式缩放
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
            } else {
                var bx = sx,
                    by = sy,
                    bw = swidth,
                    bh = sheight;
            }
            var cx = bx + bw / 2,
                cy = by + bh / 2;
            ctx.globalAlpha = 1 - 1 / (60 * endTime) * count;
            ctx.translate(cx * (1 - (1 - 1 / (endTime * 60) * count)), cy * (1 - (1 - 1 / (endTime * 60) * count)));
            ctx.scale(1 - 1 / (endTime * 60) * count, 1 - 1 / (endTime * 60) * count);
        }

        function out_fadeturn() {
            //翻转式由近及远
            ctx.globalAlpha = 1 - 1 / (60 * endTime) * count;
            var cx = getCenterPoint(shape).x,
                cy = getCenterPoint(shape).y;
            ctx.translate(cx, cy);
            ctx.rotate(Math.PI / 4 / (endTime * 60) * count);
            ctx.translate(-cx, -cy);
            ctx.translate(cx * (1 - (1 - 0.75 / (endTime * 60) * count)), cy * (1 - (1 - 0.75 / (endTime * 60) * count)));
            ctx.scale(1 - 0.75 / (endTime * 60) * count, 1 - 0.75 / (endTime * 60) * count);
        }

        function out_faderound() {
            //渐变式回旋
            ctx.globalAlpha = 1 - 1 / (60 * endTime) * count;
            var cx, cy;
            if (textInfo) {
                var bx = textInfo[0],
                    by = textInfo[1],
                    bw = textInfo[2],
                    bh = textInfo[3];
                cx = bx + bw / 2;
                cy = by + bh / 2;
            } else {
                cx = getCenterPoint(shape).x;
                cy = getCenterPoint(shape).y;
            }
            if (count <= 30 * endTime) {
                ctx.transform(1 - 2 / (30 * endTime) * count, 0, 0, 1, cx * (1 - (1 - 2 / (30 * endTime) * count)), 0);
            } else {
                ctx.transform(-1 + 2 / (30 * endTime) * (count - 30 * endTime), 0, 0, 1, cx * (1 - (-1 + 2 / (30 * endTime) * (count - 30 * endTime))), 0);
            }
        }

        function out_jump() {
            //弹跳
            ctx.beginPath();
            if (textInfo) {
                var dx = textInfo[0],
                    dy = textInfo[1],
                    dw = textInfo[2],
                    dh = textInfo[3];
            } else {
                var dx = sx,
                    dy = sy,
                    dw = swidth,
                    dh = sheight;
            }
            var cx = dx + dw / 2,
                cy = dy + dh / 2,
                dirattr = direct[1].pathPoints,
                pathPoints = [];
            for (let len = 0; len < dirattr.length; len++) {
                pathPoints.push([dirattr[len], dirattr[len + 1]]);
                len++;
            }
            var plen = pathPoints.length,
                oncecount = plen / (endTime * 60),
                num = Math.floor(oncecount * count),
                floatNum = oncecount * count - num;
            if (oncecount * count < plen && num < plen - 1) {
                var strPoint = [pathPoints[num][0], pathPoints[num][1]],
                    endPoint = [pathPoints[num + 1][0], pathPoints[num + 1][1]];
                ctx.translate(strPoint[0] + (endPoint[0] - strPoint[0]) * floatNum, strPoint[1] + (endPoint[1] - strPoint[1]) * floatNum);
                if (count > 1 && num < plen - 1) {
                    if (pathPoints[num][1] >= pathPoints[num + 1][1] && pathPoints[num][1] >= pathPoints[num - 1][1]) {
                        ctx.translate(0, cy * 0.2);
                        ctx.scale(1, 0.8);
                    }
                }
            } else {
                ctx.globalAlpha = 0;//暂时先设为0
            }
            ctx.globalAlpha && ctx.rect(dx - 0.5, dy - 0.5 + dh / (plen / oncecount) * count + 1, dw + 1, dh - dh / (plen / oncecount) * count + 1);
            ctx.clip();
        }

        function out_windowshade() {
            //百叶窗
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 水平
                    for (let i = 0; i <= 5; i++) {
                        ctx.rect(sx, sy + sheight / 6 * i, swidth, sheight / 6 / (endTime * 60) * (endTime * 60 - count))
                    }
                    break
                case 1:
                    // 垂直
                    for (let i = 0; i <= 5; i++) {
                        ctx.rect(sx + swidth / 6 * i, sy, swidth / 6 / (endTime * 60) * (endTime * 60 - count), sheight)
                    }
                    break
            }
            ctx.clip()
        }

        function out_langsam() {
            // 缓慢退出
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 下
                    ctx.translate(0, (ctx.canvas.height / 2 - sy + sheight) / (endTime * 60) * count)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
                case 1:
                    // 左
                    ctx.translate(- (sx + swidth) / (endTime * 60) * count, 0)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
                case 2:
                    // 右
                    ctx.translate((ctx.canvas.width / 2 - sx + swidth) / (endTime * 60) * count, 0)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
                case 3:
                    // 上
                    ctx.translate(0, - (sy + sheight) / (endTime * 60) * count)
                    ctx.rect(sx, sy, swidth, sheight)
                    break
            }
            ctx.clip()
        }

        function out_step() {
            // 阶梯状 左下，左上，右下， 右上
            let step = Math.floor(20 - count / (endTime * 3))
            ctx.beginPath()
            switch (direct) {
                case 2: //右下
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + i * swidth / 20, sy, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + j * swidth / 20, sy, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
                case 0: // 左下
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + swidth - i * swidth / 20, sy, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + swidth - j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + swidth - j * swidth / 20, sy, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
                case 3: //右上
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + i * swidth / 20, sy + sheight - (2 * step - i) * sheight / 20, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + j * swidth / 20, sy + sheight * (j + 20 - 2 * step) / 20, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
                case 1: // 左上
                    if (step <= 10) {
                        for (let i = 0; i <= 20; i++) {
                            if (i <= 2 * step) {
                                ctx.rect(sx + swidth - i * swidth / 20, sy + sheight - (2 * step - i) * sheight / 20, swidth / 20, (2 * step - i) * sheight / 20)
                            }
                        }
                    } else {
                        for (let j = 0; j <= 20; j++) {
                            if (j < 2 * (step - 10)) {
                                ctx.rect(sx + swidth - j * swidth / 20, sy, swidth / 20, sheight)
                            } else {
                                ctx.rect(sx + swidth - j * swidth / 20, sy + sheight * (j + 20 - 2 * step) / 20, swidth / 20, sheight - sheight * (j + 20 - 2 * step) / 20)
                            }

                        }
                    }
                    break
            }
            ctx.clip()
        }

        function out_schachbrett() {
            count = endTime * 60 - count
            // 棋盘
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 跨越
                    for (let i = 0; i <= 11; i++) {
                        for (let j = 0; j <= 5; j++) {
                            if ((i + j) % 2 == 0) {
                                if (endTime * 30 - count > 0) {
                                    ctx.rect(sx + swidth / 12 * i, sy + sheight / 6 * j, swidth / 12 / (endTime * 30) * count, sheight / 6)
                                } else {
                                    ctx.rect(sx + swidth / 12 * i, sy + sheight / 6 * j, swidth / 12, sheight / 6)
                                }
                            } else {
                                if (endTime * 30 - count < 0) {
                                    ctx.rect(sx + swidth / 12 * i, sy + sheight / 6 * j, swidth / 12 / (endTime * 30) * (count - endTime * 30), sheight / 6)
                                }
                            }
                        }
                    }
                    break
                case 1:
                    // 下
                    for (let i = 0; i <= 5; i++) {
                        for (let j = 0; j <= 11; j++) {
                            if ((i + j) % 2 == 0) {
                                if (endTime * 30 - count > 0) {
                                    ctx.rect(sx + swidth / 6 * i, sy + sheight / 12 * j, swidth / 6, sheight / 12 / (endTime * 30) * count)
                                } else {
                                    ctx.rect(sx + swidth / 6 * i, sy + sheight / 12 * j, swidth / 6, sheight / 12)
                                }
                            } else {
                                if (endTime * 30 - count < 0) {
                                    ctx.rect(sx + swidth / 6 * i, sy + sheight / 12 * j, swidth / 6, sheight / 12 / (endTime * 30) * (count - endTime * 30))
                                }
                            }
                        }
                    }
                    break
            }
            ctx.clip()
        }

        function out_sector() {
            // 扇形
            const bx = sx + swidth / 2
            const by = sy + sheight / 2
            ctx.beginPath()
            ctx.moveTo(bx, by)
            ctx.arc(bx, by, (sheight + swidth) / 2, -Math.PI * 0.5 + Math.PI / (endTime * 60) * count, Math.PI * 1.5 - Math.PI / (endTime * 60) * count);
            ctx.closePath()
            ctx.clip()
        }

        function out_loesung() {
            let step = Math.floor(20 - count / (endTime * 3))
            let w = Math.floor(swidth / 60) + 1
            let h = Math.floor(sheight / 20) + 1
            // 向内溶解
            ctx.beginPath()
            for (let i = 0; i < w; i++) {
                for (let j = 0; j < h; j++) {
                    for (let k = 1; k <= step; k++) {
                        switch (k) {
                            case 1:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 2:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 3:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 4:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 5:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 6:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 7:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 8:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 9:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 10:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 11:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 12:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 13:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 14:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 0, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                            case 15:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 16:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 0, swidth / w / 5, sheight / h / 4)
                                break
                            case 17:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 4, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 18:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 1, sy + sheight / h * j + sheight / h / 4 * 2, swidth / w / 5, sheight / h / 4)
                                break
                            case 19:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 2, sy + sheight / h * j + sheight / h / 4 * 1, swidth / w / 5, sheight / h / 4)
                                break
                            case 20:
                                ctx.rect(sx + swidth / w * i + swidth / w / 5 * 3, sy + sheight / h * j + sheight / h / 4 * 3, swidth / w / 5, sheight / h / 4)
                                break
                        }
                    }
                }
            }
            ctx.clip()
        }

        function out_square() {
            // 菱形退出
            let step = endTime * 60 - count
            ctx.beginPath()
            switch (direct) {
                case 0:
                    ctx.moveTo(sx + swidth / 2 - swidth / (endTime * 60) * step, sy + sheight / 2)
                    ctx.lineTo(sx + swidth / 2, sy + sheight / 2 - sheight / (endTime * 60) * step)
                    ctx.lineTo(sx + swidth - swidth / 2 + swidth / (endTime * 60) * step, sy + sheight / 2)
                    ctx.lineTo(sx + swidth / 2, sy + sheight - sheight / 2 + sheight / (endTime * 60) * step)
                    ctx.lineTo(sx + swidth / 2 - swidth / (endTime * 60) * step, sy + sheight / 2)
                    ctx.closePath()
                    break
                case 1:
                    if (step / (endTime * 60) < 0.5) {
                        ctx.moveTo(sx, sy)
                        ctx.lineTo(sx + swidth / (endTime * 60) * step, sy)
                        ctx.lineTo(sx, sy + sheight / (endTime * 60) * step)
                        ctx.lineTo(sx, sy)
                        ctx.closePath()
                        ctx.moveTo(sx + swidth, sy)
                        ctx.lineTo(sx + swidth - swidth / (endTime * 60) * step, sy)
                        ctx.lineTo(sx + swidth, sy + sheight / (endTime * 60) * step)
                        ctx.lineTo(sx + swidth, sy)
                        ctx.closePath()
                        ctx.moveTo(sx, sy + sheight)
                        ctx.lineTo(sx, sy + sheight - sheight / (endTime * 60) * step)
                        ctx.lineTo(sx + swidth / (endTime * 60) * step, sy + sheight)
                        ctx.lineTo(sx, sy + sheight)
                        ctx.closePath()
                        ctx.moveTo(sx + swidth, sy + sheight)
                        ctx.lineTo(sx + swidth, sy + sheight - sheight / (endTime * 60) * step)
                        ctx.lineTo(sx + swidth - swidth / (endTime * 60) * step, sy + sheight)
                        ctx.lineTo(sx + swidth, sy + sheight)
                        ctx.closePath()
                    } else {
                        ctx.moveTo(sx, sy)
                        ctx.lineTo(sx, sy + sheight)
                        ctx.lineTo(sx + swidth, sy + sheight)
                        ctx.lineTo(sx + swidth, sy)
                        ctx.lineTo(sx, sy)
                        ctx.moveTo(sx + swidth / 2, sy - sheight / 2 + sheight / (endTime * 60) * step)
                        ctx.lineTo(sx + swidth * 1.5 - swidth / (endTime * 60) * step, sy + sheight / 2)
                        ctx.lineTo(sx + swidth / 2, sy + sheight * 1.5 - sheight / (endTime * 60) * step)
                        ctx.lineTo(sx - swidth / 2 + swidth / (endTime * 60) * step, sy + sheight / 2)
                        ctx.lineTo(sx + swidth / 2, sy - sheight / 2 + sheight / (endTime * 60) * step)
                        ctx.closePath()
                    }
                    break
            }
            ctx.clip()
        }

        function out_cut() {
            // 切出
            let step = endTime * 60 - count
            ctx.beginPath()
            switch (direct) {
                case 0:
                    // 下
                    ctx.translate(0, sheight - sheight / (endTime * 60) * step)
                    ctx.rect(sx, sy, swidth, sheight / (endTime * 60) * step)
                    break
                case 1:
                    // 左
                    ctx.translate(swidth / (endTime * 60) * step - swidth, 0)
                    ctx.rect(sx + swidth - swidth / (endTime * 60) * step, sy, swidth / (endTime * 60) * step, sheight)
                    break
                case 2:
                    // 右
                    ctx.translate(swidth - swidth / (endTime * 60) * step, 0)
                    ctx.rect(sx, sy, swidth / (endTime * 60) * step, sheight)
                    break
                case 3:
                    // 上
                    ctx.translate(0, sheight / (endTime * 60) * step - sheight)
                    ctx.rect(sx, sy + sheight - sheight / (endTime * 60) * step, swidth, sheight / (endTime * 60) * step)
                    break
            }
            ctx.clip()
        }

        function out_box() {
            // 盒状退出
            let step = endTime * 60 - count
            ctx.beginPath();
            if (textInfo) {
                var infox = textInfo[0],
                    infoy = textInfo[1],
                    infowidth = textInfo[2],
                    infoheight = textInfo[3];
            }
            switch (direct) {
                case 1:
                    // 向内
                    if (textInfo) { // 上 下 左 右
                        ctx.rect(infox, infoy, infowidth, infoheight / 2 / (endTime * 60) * step);
                        ctx.rect(infox, infoy + infoheight - infoheight / 2 / (endTime * 60) * step, infowidth, infoheight / 2 / (endTime * 60) * step);
                        ctx.rect(infox, infoy, infowidth / 2 / (endTime * 60) * step, infoheight);
                        ctx.rect(infox + infowidth - infowidth / 2 / (endTime * 60) * step, infoy, infowidth / 2 / (endTime * 60) * step, infoheight);
                    } else {
                        ctx.rect(sx - 0.5, sy - 0.5, swidth + 1, sheight / 2 / (endTime * 60) * step + 1);
                        ctx.rect(sx - 0.5, sy + sheight - sheight / 2 / (endTime * 60) * step - 0.5, swidth + 1, sheight / 2 / (endTime * 60) * step + 1);
                        ctx.rect(sx - 0.5, sy - 0.5, swidth / 2 / (endTime * 60) * step + 1, sheight + 1);
                        ctx.rect(sx + swidth - swidth / 2 / (endTime * 60) * step - 0.5, sy - 0.5, swidth / 2 / (endTime * 60) * step + 1, sheight + 1);
                    }
                    break
                case 0:
                    // 向外
                    if (textInfo) {
                        ctx.rect(infox + infowidth / 2 * (1 - 1 / (endTime * 60) * step), infoy + infoheight / 2 * (1 - 1 / (endTime * 60) * step), infowidth / (endTime * 60) * step, infoheight / (endTime * 60) * step)
                    } else {
                        ctx.rect(sx + swidth / 2 * (1 - 1 / (endTime * 60) * step), sy + sheight / 2 * (1 - 1 / (endTime * 60) * step), swidth / (endTime * 60) * step, sheight / (endTime * 60) * step)
                    }
                    break
            }
            ctx.clip()
        }

        function out_winkle() {
            if (count === endTime * 30 || count === endTime * 60) {
                ctx.globalAlpha = 0;
            }
        }

        function path_all() {
            ctx.beginPath();
            let dirattr: any = direct[1].pathPoints,
                pathPoints = [];
            for (let len = 0; len < dirattr.length; len++) {
                pathPoints.push([dirattr[len], dirattr[len + 1]]);
                len++;
            }
            if (textInfo && shape) {
                // ctx.translate(getCenterPoint(shape).x, getCenterPoint(shape).y);
                // ctx.translate(-(tx + textInfo[0] + textInfo[2] / 2), -(ty + textInfo[1] + textInfo[3] / 2));
                // console.log(Math.abs(pathPoints[0][0] - (tx + textInfo[0] + textInfo[2] / 2) + getCenterPoint(shape).x))
                // // 前后台文本绘制位置不同所以拿到的路径错位，先这么处理
                // if (Math.abs(pathPoints[0][0] - (tx + textInfo[0] + textInfo[2] / 2) + getCenterPoint(shape).x) < 45 && Math.abs(pathPoints[0][1] - (ty + textInfo[1] + textInfo[3] / 2) + getCenterPoint(shape).y) < 45) {
                //     ctx.translate(-(getCenterPoint(shape).x - (tx + textInfo[0] + textInfo[2] / 2) + pathPoints[0][0]), -(getCenterPoint(shape).y - (ty + textInfo[1] + textInfo[3] / 2) + pathPoints[0][1]));
                // }
                // console.log(getCenterPoint(shape).x ,(textInfo[0] + textInfo[2] / 2))

                // console.log(getCenterPoint(shape).x - (textInfo[0] + textInfo[2] / 2),getCenterPoint(shape).y - (textInfo[1] + textInfo[3] / 2))
                ctx.translate(getCenterPoint(shape).x - (textInfo[0] + textInfo[2] / 2), getCenterPoint(shape).y - (textInfo[1] + textInfo[3] / 2));
            }
            let plen: any = pathPoints.length,
                oncecount: any = plen / (endTime * 60);
            if (oncecount * count < plen && Math.floor(oncecount * count) < plen - 1) {
                let num: number = Math.floor(oncecount * count),
                    floatNum: any = oncecount * count - num,
                    strPoint: any = [pathPoints[num][0], pathPoints[num][1]],
                    endPoint: any = [pathPoints[num + 1][0], pathPoints[num + 1][1]];
                ctx.translate(strPoint[0] + (endPoint[0] - strPoint[0]) * floatNum, strPoint[1] + (endPoint[1] - strPoint[1]) * floatNum);
            } else {
                ctx.translate(pathPoints[plen - 1][0], pathPoints[plen - 1][1]);
            }
        }

        function getDistance() {
            if (direct == 0) {
                //自/到底
                return [0, ty >= sy ? pHeight - sy : pHeight - ty];
            } else if (direct == 1) {
                //自/到左
                return [sx + swidth >= tx + twidth ? sx + swidth : tx + twidth, 0];
            } else if (direct == 2) {
                //自/到右
                return [tx >= sx ? pWidth - sx : pWidth - tx, 0];
            } else if (direct == 3) {
                //自/到顶
                return [0, ty + theight >= sy + sheight ? ty + theight : sy + sheight];
            } else if (direct == 4) {
                //自/到左下
                return [sx + swidth >= tx + twidth ? sx + swidth : tx + twidth, ty >= sy ? pHeight - sy : pHeight - ty];
            } else if (direct == 5) {
                //自/到右下
                return [tx >= sx ? pWidth - sx : pWidth - tx, ty >= sy ? pHeight - sy : pHeight - ty];
            } else if (direct == 6) {
                //自/到左上
                return [sx + swidth >= tx + twidth ? sx + swidth : tx + twidth, ty + theight >= sy + sheight ? ty + theight : sy + sheight];
            } else if (direct == 7) {
                //自/到右上
                return [tx >= sx ? pWidth - sx : pWidth - tx, ty + theight >= sy + sheight ? ty + theight : sy + sheight];
            } else {
                return [0, ty >= sy ? pHeight - sy : pHeight - ty];
            }
        }

        /**
         * 获取中心点
         */
        function getCenterPoint(shape: shape) {
            let centerPoint = Object.create(null);
            //shapeRect有数据，那就先获取这个中心点
            if (shape.shapeRect) {
                centerPoint['x'] = shape.shapeRect.x + shape.shapeRect.width / 2;
                centerPoint['y'] = shape.shapeRect.y + shape.shapeRect.height / 2;
            } else if (shape.textRect) {
                centerPoint['x'] = shape.textRect.x + shape.textRect.width / 2;
                centerPoint['y'] = shape.textRect.y + shape.textRect.height / 2;
            }
            return centerPoint
        }
    }
}
